// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ocard-caption[data-v-7800672f]{font-family:Montserrat,sans-serif;text-align:center;font-weight:900;font-size:4.6rem;line-height:5.742rem}.ocard .oimage[data-v-7800672f] .object-cover{-o-object-fit:cover!important;object-fit:cover!important}@media (min-width:768px){.ocard-caption[data-v-7800672f]{font-size:6rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
